import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { homePathForRole } from '@/lib/auth/roles';
import { useApp } from '@/hooks/use-app-context';
import { useTokenGuard } from './use-token-guard';

interface CollectorRouteProps {
  children: ReactNode;
}

const normalizeRole = (value: unknown): 'user' | 'collector' | 'moderator' | 'admin' | 'accountant' | 'super_admin' => {
  if (value === 'user' || value === 'collector' || value === 'moderator' || value === 'admin' || value === 'accountant' || value === 'super_admin') {
    return value;
  }
  if (value === 'SUPER_ADMIN') return 'super_admin';
  if (value === 'collecteur' || value === 'COLLECTOR' || value === 'COLLECTEUR' || value === 'ANNOTATOR' || value === 'ANNOTATEUR') return 'collector';
  if (value === 'ADMIN') return 'admin';
  if (value === 'MODERATOR') return 'moderator';
  if (value === 'ACCOUNTANT' || value === 'COMPTABLE') return 'accountant';
  return 'user';
};

export function CollectorRoute({ children }: CollectorRouteProps) {
  const { user } = useApp();
  const { isValid } = useTokenGuard();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || 'fr';

  if (!isValid || !user) {
    return <Navigate to={`/${currentLang}/login`} state={{ from: window.location.pathname }} replace />;
  }

  // The collector space is the collector's only; every other profile goes
  // back to its own space.
  if (normalizeRole(user.role) !== 'collector') {
    return <Navigate to={homePathForRole(user.role, currentLang)} replace />;
  }

  return <>{children}</>;
}
